import React from 'react';

import Browser from '@wetransfer/concorde-browser';

import Actions from '@app/store/action';
import Router from '@module/router';
import Store from '@app/store';
import I18n from '@module/i18n';
import Button from '@component/form/element/button';
import Illustration from '@component/illustration';
import StaticPage from '@component/panel/content';

export default class Expired extends React.Component {
  /**
   * Binds all private methods
   * @param  {Object} props Component props
   */
  constructor(props) {
    super(props);

    this.newTransfer = this.newTransfer.bind(this);
  }

  newTransfer() {
    Store.dispatch(Actions.Transfer.create());
    Router.navigateTo('/');
  }

  // Render our view
  render() {
    const { user } = Store.getState();

    const className = ['transfer__window', 'downloader'];

    let upsell = null;
    let footerButton = (
      <button
        onClick={this.newTransfer}
        className="transfer__button transfer__button--alt"
      >
        {I18n.t('transfer.buttons.new_transfer')}
      </button>
    );
    if (Browser.isMobile) {
      footerButton = (
        <Button
          onClick={this.newTransfer}
          text={I18n.t('transfer.buttons.back_to_home')}
        />
      );
      className.push('transfer__window--is-not-available');

      if (!user.loggedIn) {
        upsell = <StaticPage route={{ path: '/pro' }} />;
      }
    }

    return (
      <div className={className.join(' ')}>
        <div className="transfer__contents">
          <div className="downloader__expired">
            <Illustration type="transfer-expired" />
            <h2>{I18n.t('transfer.expired.title')}</h2>
            <p>{I18n.t('transfer.expired.text')}</p>
          </div>
        </div>
        <div className="transfer__footer">{footerButton}</div>
        {upsell}
      </div>
    );
  }
}
